export default __webpack_public_path__ + "static/media/tie_12.aae6ffb9.mp3";